export class UserInfo {
  clubUserProgramFeeID: number;
  userID: number;
  clubProgramID: number;
  clubProgramFeeID: number;
  avatar: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  dob: Date;
  age: number;
  email: string;
  dateRegistered: Date;
  clubProgramFeeAdjustmentTypeID: number;
  feeAdjustmentType: string;
  discountID: number;
  discountType: string;
  paymentTypeID: number;
  paymentStatus: string;
  inviteStatusID: number;
  inviteStatus: string;
  inviteTeamID: number;
  inviteAddedDate: Date;
  clubUserRoles: number[];
  userProgramRole: number;
  userRoles: number[];

  constructor(data: any = {}) {
    Object.keys(data).forEach(key => this[key] = data[key]);
  }

  get name() {
    return `${this.firstName} ${this.middleName} ${this.lastName}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/interfaces/tryout_interface/user-info.ts